export const SECTION_NAMES = {
    accountSecurity: 'Security',
    analytics: 'Analytics',
    analyticsReports: 'Reports',
    appInstagram: 'Instagram feed',
    appMeta: 'Instagram & Facebook Shop',
    appMetaCAPI: 'Meta Ads',
    appStreamElements: 'StreamElements alerts',
    appStreamlabs: 'Streamlabs alerts',
    appTikTok: 'TikTok feed',
    appTikTokShop: 'TikTok Shop',
    appTwitchGifting: 'Twitch gifting',
    appTwitterShops: 'X Shops',
    appYoutubeProductShelf: 'YouTube Product Shelf',
    appSpotify: 'Members-only audio on Spotify',
    apps: 'Apps',
    home: 'Home',
    themeEditor: 'Site design',
};
